$(document).on('turbolinks:load', function () {

  $(document).on('click', '.clickable-row', function () {
    var href = $(this).data('href');
    if (href && href.length > 0) {
      window.location.href = href;
    }
  });
});